<div class="boxWhite">

  <h4>BUS: {{viaje?.movil?.patente}}</h4>

  <button class="btn btnClose" (click)="close()">
    <img src="assets/img/icoClose.svg">
  </button>

  <div class="headInfo">
    <div class="servicio">
      <span>SERVICIO</span>
      <h4>{{viaje?.servicio}}</h4>
    </div>
    <div class="item">
      <span>ID VIAJE</span>
      <p>{{viaje?.viajeCodigo}}</p>
    </div>
    <div class="item">
      <span>INICIO</span>
      <p>{{muestraHora(viaje?.fechahoraInicio)}} <span class="clRed">+10m</span></p>
    </div>
    <div class="item">
      <span>ORIGEN</span>
      <p>{{viaje?.sucursalOrigen.nombre}}</p>
    </div>
    <div class="item">
      <span>SENTIDO</span>
      <p>{{viaje?.sentido}}</p>
    </div>
    <div class="item">
      <span>DESTINO</span>
      <p>{{viaje?.sucursalDestino.nombre}}</p>
    </div>
    <div class="item">
      <span>LLEGADA</span>
      <p>{{muestraHora(viaje?.fechahoraLlegada)}} <span
          *ngIf="viaje?.fechahoraLlegada">{{muestraDiferenciaHorasMinutos(viaje.fechahoraTermino,
          viaje.fechahoraLlegada)}}</span></p>
    </div>
  </div>


  <div class="contBoxes">

    <div class="box vehiculo">

      <div class="rowItems">
        <div class="item">
          <span>ID BUS</span>
          <p>{{viaje?.movil?.numeroInterno}}</p>
        </div>
        <div class="item">
          <span>PATENTE</span>
          <p>{{viaje?.movil?.patente}}</p>
        </div>
        <div class="item">
          <span>TIPO DE BUS</span>
          <p>{{viaje?.movil?.tipoMovil?.codigo}}</p>
        </div>
        <div class="item">
          <span>COMBUSTIBLE I.</span>
          <p>{{detalleViaje?.movil?.estadoInicio?.capacidadPorcentaje}}%</p>
        </div>
        <div class="item">
          <span>BUS INHABILIDAD</span>
          <div class="form-check form-switch">
            <input class="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckDefault"
              [(ngModel)]="busInhabilitado" (change)="verificaBusInhabilitado()">
          </div>
        </div>
        <div class="item doble">
          <span>% COMBUSTIBLE/BATERÍA</span>
          <input type="range" class="form-range" min="0" max="100" step="1" [(ngModel)]="porcentajeCombustible">
        </div>

        <div class="item doble">
          <span>% COMBUSTIBLE / BATERÍA ACTUAL</span>
          <p class="clRed">{{porcentajeCombustible}}%</p>
          <!-- class="clRed" solo poner clase cuando se da acción terminado el viaje-->
        </div>
      </div>

      <div class="radios mt-3">
        <label class="itemRadio">
          <input type="radio" name="radioBus" [(ngModel)]="estadoBus" value="DISPONIBLE" (change)="cambioEstadoBus()">
          <span class="boxRadio">
            <span class="ico"><img src="assets/img/icoPatio.svg"></span>
            DISPONIBLE
          </span>
        </label>
        <label class="itemRadio">
          <input type="radio" name="radioBus" [(ngModel)]="estadoBus" value="EN_LAVADO" (change)="cambioEstadoBus()">
          <span class="boxRadio">
            <span class="ico"><img src="assets/img/icoLavado.svg"></span>
            LLEVAR A LAVADO <!--<span class="clGray">(20m)</span>-->
          </span>
        </label>
        <!--<label class="itemRadio">
          <input type="radio" name="radioBus" [(ngModel)]="estadoBus" value="EN_LAVADO_PROFUNDO">
          <span class="boxRadio">
            <span class="ico"><img src="assets/img/icoLavado.svg"></span>
            LLEVAR A LAVADO PROFUNDO <span class="clGray">(40m)</span>
          </span>
        </label>-->
        <label class="itemRadio">
          <input type="radio" name="radioBus" [(ngModel)]="estadoBus" value="EN_TALLER" (change)="cambioEstadoBus()">
          <span class="boxRadio">
            <span class="ico"><img src="assets/img/icoTaller.svg"></span>
            LLEVAR A TALLER
          </span>
        </label>
        <label class="itemRadio">
          <input type="radio" name="radioBus" [(ngModel)]="estadoBus" value="EN_CARGA" (change)="cambioEstadoBus()">
          <span class="boxRadio">
            <span class="ico"><img src="assets/img/icoDieselOrange.svg"></span>
            CARGAR COMBUSTIBLE/BATERÍA
          </span>
        </label>
        <!-- <label class="itemRadio">
          <input type="radio" name="radioBus" [(ngModel)]="estadoBus" value="NO_DISPONIBLE"
            (change)="cambioEstadoBus()">
          <span class="boxRadio clRed">
            <span class="ico">
              <img src="assets/img/icoNoDisponible.svg">
            </span>
            DEJAR NO DISPONIBLE
          </span>
        </label> -->
      </div>

      <!--
      <div class="boxAccion mt-3" style="color: var(--red)">
        <img src="assets/img/icoDieselRed.svg"> EN CARDA DE COMBUSTIBLE / ENERGÍA
      </div>-->


    </div>

    <div class="box conductor">
      <div class="rowItems">
        <div class="item">
          <span>ID CONDUCTOR</span>
          <p>{{viaje?.conductor?.visibleId}}</p>
        </div>
        <div class="item">
          <span>NOMBRE CB</span>
          <p>{{viaje?.conductor?.nombres}} {{viaje?.conductor?.apellidoPaterno}}</p>
        </div>
        <div class="item">
          <span>HORAS DISPONIBLES</span>
          <p>{{mostraHorasDisponibles()}}</p>
        </div>
        <div class="item">
          <span>AUTDO / H. EXTRAS</span>
          <p>{{(viaje?.conductor?.hhExtraAutorizadas) ? 'SI' : 'NO'}} /
            {{convertirMinutosEnHoras(viaje?.conductor?.jornadaEnCurso?.horasExtra)}}</p>
        </div>
        <div class="item doble">
          <span>TERMINAL CONTRATO</span>
          <p>{{viaje?.conductor?.contratoSucursal?.nombre}}</p>
        </div>
      </div>

      <div class="radios mt-3">
        <label class="itemRadio">
          <input type="radio" name="radioConductor" [(ngModel)]="estadoConductor" value="DISPONIBLE"
            (change)="cambioEstadoConductor()">
          <span class="boxRadio">
            <span class="ico"><img src="assets/img/icoDisponible.svg"></span>
            DISPONIBLE
          </span>
        </label>
        <label class="itemRadio">
          <input type="radio" name="radioConductor" [(ngModel)]="estadoConductor" value="CAPACITACION"
            (change)="cambioEstadoConductor()">
          <span class="boxRadio">
            <span class="ico">
              <img src="assets/img/icoCapacitacion.svg">
            </span>
            CAPACITACIÓN
          </span>
        </label>
        <label class="itemRadio">
          <input type="radio" name="radioConductor" [(ngModel)]="estadoConductor" value="REVISION_TECNICA"
            (change)="cambioEstadoConductor()">
          <span class="boxRadio">
            <span class="ico">
              <img src="assets/img/icoRevisionTecnica.svg">
            </span>
            EN REVISIÓN TÉCNICA
          </span>
        </label>
        <label class="itemRadio">
          <input type="radio" name="radioConductor" [(ngModel)]="estadoConductor" value="EN_PATIO"
            (change)="cambioEstadoConductor()">
          <span class="boxRadio">
            <span class="ico"><img src="assets/img/icoPatio.svg"></span>
            APOYO PATIO
          </span>
        </label>
        <label class="itemRadio" *ngIf="detalleViaje?.conductor?.tipoContrato?.toUpperCase() == 'FULL_TIME'">
          <input type="radio" name="radioConductor" [(ngModel)]="estadoConductor" value="EN_COLACION"
            (change)="cambioEstadoConductor()">
          <span class="boxRadio">
            <span class="ico"><img src="assets/img/icoColacion.svg"></span>
            COLACIÓN <span class="clGray">(30m)</span>
          </span>
        </label>
        <label class="itemRadio">
          <input type="radio" name="radioConductor" [(ngModel)]="estadoConductor" value="EN_TALLER"
            (change)="cambioEstadoConductor()">
          <span class="boxRadio">
            <span class="ico"><img src="assets/img/icoTaller.svg"></span>
            TRASLADO BUS A TALLER
          </span>
        </label>
        <!-- <label class="itemRadio">
          <input type="radio" name="radioConductor" [(ngModel)]="estadoConductor" value="FUERA_JORNADA"
            (change)="cambioEstadoConductor()">
          <span class="boxRadio clRed">
            <span class="ico"><img src="assets/img/icoFinJornada.svg"></span>
            NO DISPONIBLE
          </span>
        </label> -->

        <label class="itemRadio" *ngIf="puedeFinalizarJornada">
          <input type="radio" name="radioConductor" [(ngModel)]="estadoConductor" value="FINALIZAR_E_IMPRIMIR"
            (change)="cambioEstadoConductor()">
          <span class="boxRadio clOrange">
            <span class="ico"><img src="assets/img/icoFinJornada.svg"></span>
            FINALIZAR & IMPRIMIR
          </span>
        </label>
      </div>

      <!--
      <div class="boxAccion mt-3">
        <img src="assets/img/icoColacion.svg"> EN COLACIÓN <span>(30M)</span>
      </div>-->

    </div>

    <button *ngIf="tienePermisoFinalizarViaje()" class="btn btnRed" [disabled]="enviando" (click)="postFinalizarViaje()">
      <span *ngIf="enviando" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
      TERMINAR VIAJE
    </button>
  </div>

</div>